module.exports = __webpack_public_path__ + "static/media/Blastoise_gaussian2.ba5cbd0c.png";